export default __webpack_public_path__ + "static/media/foot.65fa7e19.svg";